import { useTranslation } from '../../core/hooks/use-translation';
import type { TranslationKey } from '../../core/i18n/translation';
import { company, telHref } from '../../site/company';
import { ClockIcon, PhoneIcon, ShieldIcon, UsersIcon } from './booking-icons';

const FEATURES: readonly {
    readonly title: TranslationKey;
    readonly text: TranslationKey;
}[] = [
    { title: 'booking.side.f1_title', text: 'booking.side.f1_text' },
    { title: 'booking.side.f2_title', text: 'booking.side.f2_text' },
    { title: 'booking.side.f3_title', text: 'booking.side.f3_text' }
];

/**
 * The reassurance rail beside the wizard, shown from 1200px up and hidden below it by the
 * stylesheet — it is the widescreen page's second column, and on a telephone the form is the page.
 *
 * The live page writes each feature as one translated HTML fragment with a `<strong>` inside it,
 * which makes a translator's stray tag a rendering bug. Here the heading and the sentence are two
 * keys and the markup is markup, as the landing-page port already does everywhere else.
 *
 * The phone number comes from `company`, so the dialled and the displayed forms cannot drift.
 */
export function BookingSideInfo() {
    const { t } = useTranslation();
    const icons = [<ShieldIcon key="shield" />, <ClockIcon key="clock" />, <UsersIcon key="users" />];

    return (
        <aside className="side-info">
            <div className="side-card">
                <h2 className="side-card-title">{t('booking.side.why')}</h2>

                {FEATURES.map((feature, index) => (
                    <div key={feature.title} className="side-feature">
                        <div className="side-feat-icon">{icons[index]}</div>
                        <p className="side-feat-text">
                            <strong>{t(feature.title)}</strong>
                            {t(feature.text)}
                        </p>
                    </div>
                ))}
            </div>

            <div className="side-contact">
                <div className="side-contact-icon">
                    <PhoneIcon />
                </div>
                <p className="side-contact-text">
                    <strong>
                        <a href={telHref(company.phone)}>{company.phone}</a>
                    </strong>
                    {t('booking.side.contact_note')}
                </p>
            </div>
        </aside>
    );
}
